import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {
  constructor() { }

  // Simple wrapper around the environment object,
  // to allow for easy mocking in tests.
  environment = Object.freeze(environment);
}
